import _default from './TemplateTag';
export { _default as default };
